var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tel"},[_c('v-icon',{attrs:{"size":"18px"}},[_vm._v("phone")]),_vm._v(_vm._s(_vm._f("i18n")(_vm.phone)))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }